import { LPD } from '@/components/layout/LPD.tsx'
import PFG from '@/components/layout/PFG.tsx'
// import { strapiLoader } from '@/libs/strapi/loader.ts'
import { StrapiLayoutResolver } from '@/libs/strapi/resolvers/StrapiLayoutResolver.tsx'
import { StrapiRootResolver } from '@/libs/strapi/resolvers/StrapiRootResolver.tsx'
import { Outlet, useLoaderData, useParams } from '@remix-run/react'
import { PropsWithChildren } from 'react'

// export const loader = strapiLoader

// export default StrapiRootResolver
type StrapiLayoutResolverProps = PropsWithChildren<{
	/**
	 * This maps the sub domain to the group slug from strapi
	 */
	config: Record<string, (...args: any) => JSX.Element>
}>

export default function Index() {
	const { page, child } = useParams()

	return (
		<div>
			{page} {child}
		</div>
	)
}
